import React from "react";
import { useEffect } from "react";
import { FaCheckCircle } from "react-icons/fa";


const AdminAutoTaskItem =({litOfAutoTask})=>{

    useEffect(()=>{
        console.log("Data In Item: ",litOfAutoTask)
    },[litOfAutoTask])

    return (
        <main className="dashboard-main">
          <h2>Automatic Tasks</h2>
    
          <ul className="task-list-auto-task">
            {litOfAutoTask && litOfAutoTask.length > 0 ? (
              litOfAutoTask.map((task, index) => (
                <li
                  key={task.id || index}
                  className={`task-item-auto-task`}
                >
                 {task.code_discript == "Successful"?<FaCheckCircle className="success-icon" />:null}
                  <p>Task Date: {task.date_completed}</p>
                  <p>Task Name: {task.name}</p>
                  <p>Task Status: {task.code_discript}</p>
                </li>
              ))
            ) : (
              <p>No tasks found.</p>
            )}
          </ul>
        </main>
      );
}

export default AdminAutoTaskItem;
